const ROUTES = {
  HOME: '/',
  
  // OctopusSync routes
  OCTOPUSSYNC: '/octopussync',
  OCTOPUSSYNC_FEATURES: '/octopussync/features',
  OCTOPUSSYNC_PRICING: '/octopussync/pricing',
  OCTOPUSSYNC_HOW_TO: '/octopussync/how-to',
  
  // Other pages
  LOGIN: '/login',
  CONTACTS: '/contacts',
  FEATURE_REQUEST: '/feature-request',
  
  NOT_FOUND: '/404'
};

export default ROUTES;
